<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-10">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="6" vs-sm="4" vs-xs="12">
          <h3>Populate Account and Contact Requests - Campaigns</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="2" vs-sm="4" vs-xs="12">
          <vs-button @click="populateAllAccountContactRequestCampaignDatas">Populate All Data</vs-button>
        </vs-col>
      </vs-row>
      <DataGrid :context="'PopulateAccountContactRequest'" :rowSelection="'single'" ref="campaignsList"
        :columnDefs="campaignsColumnDefs" :rowData="campaignsRecords" :dataSource="campaignsDataSource"
        @openAccountContactRequestPopulateDataPopUp="openAccountContactRequestPopulateDataPopUp">
      </DataGrid>
    </vx-card>

    <vs-popup title="UnReviewed Account Contact Request Data" :active.sync="UnReviewedRequestAccountContactDataPopUp">

      <div>
        <h6 class="text-center"> Listed below the campaigns which are in under reviewed. </h6>
        <h6 class="text-center"> Please review the data changes and populate again. </h6>

      </div>
      <div>
      </div>

      <div class="vx-row p-5" v-if="unreviewed_request_account_contact_campaigns">

        <div class="vx-col w-full">

          <div v-for="unreviewed_campaign, index in unreviewed_request_account_contact_campaigns">


            <h6 class="ml-5">{{ index + 1 }} . <a class="pointer"
                @click="gotoAccount_ContactRequestReviewPage(unreviewed_campaign)">{{ unreviewed_campaign['camp_name'] }}</a>
            </h6>
            <vs-divider class="p-1" />

          </div>
        </div>


      </div>


    </vs-popup>

    <vs-popup title="UnReviewed Sales Developer Data" :active.sync="UnReviewedSalesDeveloperDataPopUp">

      <div>
        <h6 class="text-center"> Listed below the campaigns which are in under reviewed. </h6>
        <h6 class="text-center"> Please review the data changes and refresh again. </h6>

      </div>
      <div>
      </div>

      <div class="vx-row p-5" v-if="unreviewed_campaigns">

        <div class="vx-col w-full">

          <div v-for="unreviewed_campaign, index in unreviewed_campaigns">


            <h6 class="ml-5">{{ index + 1 }} . <a class="pointer"
                @click="gotoReviewPage(unreviewed_campaign)">{{ unreviewed_campaign['camp_name'] }}</a></h6>
            <vs-divider class="p-1" />

          </div>
        </div>


      </div>

      <vs-row vs-w="12" v-if="refreshInBulk">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
          <vs-button @click="refreshReviewedCampaignData">Refresh</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="6" vs-sm="6" vs-xs="6">
          <vs-button @click="UnReviewedSalesDeveloperDataPopUp = false">Exit</vs-button>
        </vs-col>

      </vs-row>

    </vs-popup>




  </div>
</template>

<script>
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignFieldsManagement from "@/store/fields-management/campaign-fields-management/moduleCampaignFieldsManagement.js";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
import axios from "@/axios.js";
export default {
  data: () => ({
    UnReviewedSalesDeveloperDataPopUp: false,
    unreviewed_campaigns: [],
    user_id: null,
    refreshInBulk: true,
    allCampaigns: [],
    unreviewed_request_account_contact_campaigns: [],
    UnReviewedRequestAccountContactDataPopUp: false,
    abilities: null,
    campaignsColumnDefs: [
      {
        headerName: "Actions",
        field: "transactions",
        cellRenderer: "CellRendererActions",
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 60
      },
      {
        headerName: "Campaign",
        field: "camp_name",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Campaign Code",
        field: "campaign_code",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Start Date",
        field: "start_date",
        flex: 1,

        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "End Date",
        field: "end_date",
        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    campaignsRecords: [],
    selected_campaign: null
  }),
  components: {
    "v-select": vSelect,
    moduleCampaignFieldsManagement,
    DataGrid
  },
  watch: {},
  methods: {
    gotoReviewPage(campaign) {

      if (campaign) {
        this.UnReviewedSalesDeveloperDataPopUp = false
      }

      this.$router.push({
        path: "/quality_control/review_data/" + campaign.campaign_id + '/' + btoa(campaign.campaign_name)
      });

    },
    gotoAccount_ContactRequestReviewPage(campaign) {

      if (campaign) {
        this.UnReviewedRequestAccountContactDataPopUp = false
      }

      this.$router.push({
        path: "/quality_control/account_contact_requests/review_data/" + campaign.campaign_id + '/' + btoa(campaign.campaign_name)
      });

    },

    populateAllAccountContactRequestCampaignDatas() {
      let self = this;
      self.refreshInBulk = true
      self.$store
        .dispatch(
          "campaignsManagement/getAccountContactRequestUnReviewedCampaigns",
        )
        .then(function (response) {
          let response_data = JSON.parse(response.data);
          if (response_data.length != 0) {
            self.unreviewed_request_account_contact_campaigns = response_data


            const key = 'campaign_id';

            self.unreviewed_request_account_contact_campaigns = [...new Map(self.unreviewed_request_account_contact_campaigns.map(item =>
              [item[key], item])).values()];




            self.UnReviewedRequestAccountContactDataPopUp = true
          }
          else {

            self.refreshAllCampaignDatas()





          }
        })


    },
    refreshAllCampaignDatas() {
      let self = this;
      self.refreshInBulk = true
      self.$store
        .dispatch(
          "campaignsManagement/getUnReviewedCampaigns",
        )
        .then(function (response) {
          let response_data = JSON.parse(response.data);
          if (response_data.length != 0) {
            self.unreviewed_campaigns = response_data


            const key = 'campaign_id';

            self.unreviewed_campaigns = [...new Map(self.unreviewed_campaigns.map(item =>
              [item[key], item])).values()];



            self.UnReviewedSalesDeveloperDataPopUp = true
          }
          else {
            self.allCampaigns.forEach(element => {
              self.populatAccountContactRequestAllData(element)
            });


            self.UnReviewedSalesDeveloperDataPopUp = false
          }
        })


    },
    populatAccountContactRequestAllData(selected_campaign) {


      console.log(selected_campaign)
      let self = this;
      self.$vs.loading();
      self.$store
        .dispatch("campaignsManagement/populateAccountContactRequestData", selected_campaign.campaign_id)
        .then(res => {
          console.log(res.data)


          if (res.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Populate Data",
              text: res.data.message
            });



            var currentdate = new Date();
            var datetime = currentdate.getFullYear() + "-"
              + (currentdate.getMonth() + 1) + "-"
              + currentdate.getDate() + " "
              + currentdate.getHours() + ":"
              + currentdate.getMinutes() + ":"
              + currentdate.getSeconds();

            // alert("Data populated successfully at " + datetime);





          } else {

            self.$vs.notify({
              color: "failed",
              title: "Populate Data",
              text: res.data.message
            });

          }

          self.$vs.loading.close();

        })
        .catch(err => {
          console.log(err);
        });
    },
    openAccountContactRequestPopulateDataPopUp(value) {



      let self = this;
      self.$vs.loading();
      self.selected_campaign = value;
      self.selected_campaign_id = value.campaign_id;

      self.$store
        .dispatch(
          "campaignsManagement/getAccountContactRequestUnReviewedCampaigns",
          self.selected_campaign_id
        )
        .then(function (response) {
          let response_data = JSON.parse(response.data);
          self.unreviewed_request_account_contact_campaigns = []
          self.refreshInBulk = false

          if (response_data.length == 0) {

            self.$vs.loading.close();

            self.$vs.loading();



            self.$store
              .dispatch(
                "campaignsManagement/getUnReviewedCampaigns",
              )
              .then(function (response) {
                let response_data = JSON.parse(response.data);
                self.unreviewed_campaigns = []
                self.refreshInBulk = false

                if (response_data.length == 0) {
                  self.populatAccountContactRequestAllData(self.selected_campaign)
                  self.UnReviewedRequestAccountContactDataPopUp = false
                } else {
                  response_data.forEach(element => {
                    if (element.campaign_id == self.selected_campaign_id) {
                      self.unreviewed_campaigns.push(element)
                      self.UnReviewedSalesDeveloperDataPopUp = true
                    }

                  });


                  if (self.unreviewed_campaigns.length == 0) {
                    self.populatAccountContactRequestAllData(self.selected_campaign)
                    self.UnReviewedRequestAccountContactDataPopUp = false
                  } else {
                    self.UnReviewedSalesDeveloperDataPopUp = true
                  }

                }

                self.$vs.loading.close();





              })









          } else {


            response_data.forEach(element => {
              if (element.campaign_id == self.selected_campaign_id) {




                self.unreviewed_request_account_contact_campaigns.push(element)
                self.UnReviewedRequestAccountContactDataPopUp = true
              }

            });


            if (self.unreviewed_request_account_contact_campaigns.length == 0) {



              self.populatAccountContactRequestAllData(self.selected_campaign)
              self.UnReviewedRequestAccountContactDataPopUp = false
            } else {
              self.UnReviewedRequestAccountContactDataPopUp = true
            }

          }


          self.$vs.loading.close();




        })


    },
    getcampaignDataSource() {
      var self = this;

      this.campaignsDataSource = {
        getRows(params) {
          self.$store
            .dispatch(
              "campaignsManagement/getAllCampaignsForAccountContactRequestPopulateData",
              params.request
            )
            .then(function (response) {
              let response_data = response.rows;
              self.allCampaigns = response_data
              console.log("Campaigns", response_data);
              if (response_data.length != 0) {
                params.success({ rowData: response.rows, rowCount: response.lastRow })
              } else {
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function () {
      this.$router.go(-1);
    }
  },
  beforeMount() {
    this.getcampaignDataSource();
  },
  mounted() {
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    if (!moduleCampaignFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "CampaignFieldsManagement",
        moduleCampaignFieldsManagement
      );
      moduleCampaignFieldsManagement.isRegistered = true;
    }
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
